import React, { useRef } from "react";
import emblem from "../../Assets/icons/Emblem_of_India.png";
import rcFrontBg from "../../Assets/images/rc-front-bg.jpg";
import rcBackBg from "../../Assets/images/rc-back-bg.jpg";
import { getStateFromVehicleNumber } from "../../Utils/helpers";
import moment from "moment";
import { QRCodeCanvas } from "qrcode.react";

export default function VehicleRegistrationCard({ rcData }) {
  const cardRef = useRef();

  return (
    <div ref={cardRef} className="flex gap-4 items-start">
      {/* Card to convert */}
      <div
        id="rc-card"
        className="mx-auto text-gray-900 font-sans relative overflow-hidden bg-contain bg-center bg-no-repeat w-[540px] h-[337px]"
        style={{ backgroundImage: `url(${rcFrontBg})` }}
      >
        {/* Header */}
        <div className="flex items-start justify-between px-6 py-4">
          <div>
            <div className="flex items-start">
              <img src={emblem} alt="Emblem of India" className="h-[70px]" />
              <div className="ml-10 pb-2">
                <h2 className="font-semibold text-[0.7rem] block">
                  Indian Union Vehicle Registration Certificate
                </h2>
                <p className="text-[0.7rem] text-gray-700">
                  Issued by{" "}
                  <span className="font-semibold uppercase">
                    GOVERNMENT OF {getStateFromVehicleNumber(rcData?.rcNumber)}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-start space-x-2">
            <div className="w-8 h-8 pb-4 rounded-full bg-sky-400 flex items-center justify-center text-black font-bold text-[0.7rem] border border-black">
              {rcData?.is_commercial ? "T" : "NT"}
            </div>
            <div className="w-8 h-8 pb-4 rounded-full bg-orange-400 flex items-center justify-center text-black font-bold text-[0.7rem] border border-black">
              {rcData?.rcNumber
                ? String(rcData?.rcNumber).substring(0, 2).toUpperCase()
                : "NA"}
            </div>
          </div>
        </div>

        {/* Body */}

        <div className="flex items-end p-4 gap-4 -mt-11">
          <div className="w-[120px] relative bottom-[10px]">
            <p>
              <span className="block font-semibold text-[0.7rem] -mb-1">
                Fuel Type
              </span>
              <span className="text-[0.7rem] block">
                {rcData?.vehicle_data?.fuel_type}
              </span>
            </p>
            <p>
              <span className="block font-semibold text-[0.7rem] -mb-1">
                Emission Norm
              </span>
              <span className="text-[0.7rem] block">{rcData?.norms_type}</span>
            </p>
          </div>
          <div className="pb-4 pr-3 flex flex-col gap-[0.05rem] w-full relative">
            <div className="flex gap-4 items-start">
              <p>
                <span className="block font-semibold text-[0.7rem] -mb-1">
                  Regn No.
                </span>
                <span className="text-[0.7rem] block">
                  {rcData?.rcNumber ? rcData?.rcNumber : "NA"}
                </span>
              </p>
              <p>
                <span className="block font-semibold text-[0.7rem] -mb-1">
                  Date of Regn.
                </span>
                <span className="text-[0.7rem] block">
                  {moment(new Date(rcData?.issue_date)).format("DD-MMM-YYYY")}
                </span>
              </p>
              <p>
                <span className="block font-semibold text-[0.7rem] -mb-1">
                  Regn. Validity
                </span>
                <span className="text-[0.7rem] block">
                  {moment(new Date(rcData?.expiry_date)).format("DD-MMM-YYYY")}
                </span>
              </p>
              <div className="flex items-center gap-2">
                <span className="font-semibold text-[0.7rem] block">
                  Owner
                  <br />
                  Serial
                </span>
                <div className="border relative -mt-[14px] top-[16px] border-black rounded-full px-2 py-0.5 w-[30px] h-[30px]">
                  <span className="absolute bottom-[10px]">
                    {rcData?.owner_data?.serial}
                  </span>
                </div>
              </div>
            </div>
            <p>
              <span className="block font-semibold text-[0.7rem] -mb-1">
                Chassis No.
              </span>
              <span className="text-[0.7rem] block">
                {rcData?.vehicle_data?.chassis_number}
              </span>
            </p>
            <p>
              <span className="block font-semibold text-[0.7rem] -mb-1">
                Engine/Motor No.
              </span>
              <span className="text-[0.7rem] block">
                {rcData?.vehicle_data?.engine_number}
              </span>
            </p>
            <p>
              <span className="block font-semibold text-[0.7rem] -mb-1">
                Owner Name
              </span>
              <span className="text-[0.7rem] block">
                {rcData?.owner_data?.name}
              </span>
            </p>
            <p>
              <span className="block font-semibold text-[0.7rem] -mb-1">
                Son/Wife/Daughter of{" "}
                <small>(In case of Individual Owner)</small>
              </span>
              <span className="text-[0.7rem] block">
                {rcData?.owner_data?.father_name
                  ? rcData?.owner_data?.father_name
                  : "N/A"}
              </span>
            </p>
            <p>
              <span className="block font-semibold text-[0.7rem] -mb-1">
                Address
              </span>
              <span className="text-[0.7rem] block">
                {rcData?.owner_data?.permanent_address}
              </span>
            </p>
            <p className="absolute -right-[65px] bottom-[40%] text-[0.7rem] -rotate-90">
              Card Issue Date {"("}
              {rcData?.issue_date
                ? moment(new Date(rcData?.issue_date)).format("DD-MMM-YYYY")
                : "N/A"}
              {")"}
            </p>
          </div>
        </div>
      </div>
      <div
        id="rc-card"
        className="mx-auto text-gray-900 font-sans relative overflow-hidden bg-contain bg-center bg-no-repeat w-[540px] h-[337px]"
        style={{ backgroundImage: `url(${rcBackBg})` }}
      >
        {/* Header */}
        <div className="flex items-start justify-start px-6 py-4">
          <div className="flex items-start space-x-2">
            <div className="w-8 h-8 pb-4 rounded-full bg-sky-400 flex items-center justify-center text-black font-bold text-[0.7rem] border border-black">
              {rcData?.is_commercial ? "T" : "NT"}
            </div>
            <div className="w-8 h-8 pb-4 rounded-full bg-orange-400 flex items-center justify-center text-black font-bold text-[0.7rem] border border-black">
              {rcData?.rcNumber
                ? String(rcData?.rcNumber).substring(0, 2).toUpperCase()
                : "NA"}
            </div>
          </div>
          <div>
            <div className="flex items-start">
              <div className="ml-10">
                <p className="text-[0.7rem] text-gray-700">
                  <span className="font-semibold">Vehicle Class: </span>
                  <span className="uppercase">
                    {rcData?.vehicle_data?.category_description
                      ? rcData?.vehicle_data?.category_description
                      : "N/A"}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Body */}

        <div className="flex items-start p-4 gap-4 -mt-6">
          <div className="w-[150px] relative">
            <p>
              <span className="block font-semibold text-[0.7rem] -mb-1">
                Regn. Number
              </span>
              <span className="text-[0.7rem] block">
                {rcData?.rcNumber ? rcData?.rcNumber : "N/A"}
              </span>
            </p>
            <div className="w-[100px] mt-3 mb-1">
              <QRCodeCanvas
                size={115}
                value="https://qr.parivahan.gov.in/qrCodeV/vahan/view/printRcDtls.xhtml?faces-redirect=true"
              />
            </div>
            <p>
              <span className="block font-semibold text-[0.7rem] -mb-1">
                Month-Year of Mfg.
              </span>
              <span className="text-[0.7rem] block">
                {rcData?.vehicle_data?.manufactured_date
                  ? rcData?.vehicle_data?.manufactured_date
                  : "N/A"}
              </span>
            </p>
            <p>
              <span className="block font-semibold text-[0.7rem] -mb-1">
                No. of Cylinders
              </span>
              <span className="text-[0.7rem] block">
                {rcData?.vehicle_data?.number_of_cylinders
                  ? rcData?.vehicle_data?.number_of_cylinders
                  : "N/A"}
              </span>
            </p>
          </div>
          <div className="pb-4 flex flex-col gap-[0.05rem] w-full relative">
            <p>
              <span className="block font-semibold text-[0.7rem] -mb-1">
                Maker's Name:
              </span>
              <span className="text-[0.7rem] block">
                {rcData?.vehicle_data?.maker_description
                  ? rcData?.vehicle_data?.maker_description
                  : "N/A"}
              </span>
            </p>
            <p>
              <span className="block font-semibold text-[0.7rem] -mb-1">
                Model Name:
              </span>
              <span className="text-[0.7rem] block">
                {rcData?.vehicle_data?.maker_model
                  ? rcData?.vehicle_data?.maker_model
                  : "N/A"}
              </span>
            </p>
            <div className="flex gap-4 items-start">
              <p>
                <span className="block font-semibold text-[0.7rem] -mb-1">
                  Colour
                </span>
                <span className="text-[0.7rem] block">
                  {rcData?.vehicle_data?.color
                    ? rcData?.vehicle_data?.color
                    : "N/A"}
                </span>
              </p>
              <p>
                <span className="block font-semibold text-[0.7rem] -mb-1">
                  / Body Type
                </span>
                <span className="text-[0.7rem] block">
                  {"/ "}
                  {rcData?.vehicle_data?.body_type
                    ? rcData?.vehicle_data?.body_type
                    : "N/A"}
                </span>
              </p>
            </div>
            <div className="flex gap-4 items-start">
              <p>
                <span className="block font-semibold text-[0.7rem] -mb-1">
                  Seating(in all)
                </span>
                <span className="text-[0.7rem] block">
                  {rcData?.vehicle_data?.seating_capacity
                    ? rcData?.vehicle_data?.seating_capacity
                    : "0"}
                </span>
              </p>
              <p>
                <span className="block font-semibold text-[0.7rem] -mb-1">
                  / Standing
                </span>
                <span className="text-[0.7rem] block">
                  {"/ "}
                  {rcData?.vehicle_data?.standing_capacity
                    ? rcData?.vehicle_data?.standing_capacity
                    : "0"}
                </span>
              </p>
              <p>
                <span className="block font-semibold text-[0.7rem] -mb-1">
                  / Sleeper Capacity
                </span>
                <span className="text-[0.7rem] block">
                  {"/ "}
                  {rcData?.vehicle_data?.sleeper_capacity
                    ? rcData?.vehicle_data?.sleeper_capacity
                    : "0"}
                </span>
              </p>
            </div>
            <div className="flex gap-4 items-start">
              <p>
                <span className="block font-semibold text-[0.7rem] -mb-1">
                  Unladen
                </span>
                <span className="text-[0.7rem] block">
                  {rcData?.vehicle_data?.unladen_weight
                    ? rcData?.vehicle_data?.unladen_weight
                    : "0"}
                </span>
              </p>
              <p>
                <span className="block font-semibold text-[0.7rem] -mb-1">
                  / Laden
                </span>
                <span className="text-[0.7rem] block">
                  {"/ "}
                  {rcData?.vehicle_data?.laden_weight
                    ? rcData?.vehicle_data?.laden_weight
                    : "0"}
                </span>
              </p>
              <p>
                <span className="block font-semibold text-[0.7rem] -mb-1">
                  / Gross Combination Weight (Kg)
                </span>
                <span className="text-[0.7rem] block">
                  {"/ "}
                  {rcData?.vehicle_data?.gross_weight
                    ? rcData?.vehicle_data?.gross_weight
                    : "0"}
                </span>
              </p>
            </div>
            <div className="flex gap-4 items-start">
              <p>
                <span className="block font-semibold text-[0.7rem] -mb-1">
                  Cubic Cap.
                </span>
                <span className="text-[0.7rem] block">
                  {rcData?.vehicle_data?.cubic_capacity
                    ? rcData?.vehicle_data?.cubic_capacity
                    : "0"}
                </span>
              </p>
              <p>
                <span className="block font-semibold text-[0.7rem] -mb-1">
                  / Horse Power (BHP/Kw)
                </span>
                <span className="text-[0.7rem] block">
                  {"/ "}
                  {rcData?.vehicle_data?.horse_power
                    ? rcData?.vehicle_data?.horse_power
                    : "0"}
                </span>
              </p>
              <p>
                <span className="block font-semibold text-[0.7rem] -mb-1">
                  / Wheel Base(mm)
                </span>
                <span className="text-[0.7rem] block">
                  {"/ "}
                  {rcData?.vehicle_data?.wheelbase
                    ? rcData?.vehicle_data?.wheelbase
                    : "N/A"}
                </span>
              </p>
            </div>
            {rcData?.financier && (
              <div className="flex gap-4 items-start">
                <p>
                  <span className="block font-semibold text-[0.7rem] -mb-1">
                    Financer Name
                  </span>
                  <span className="text-[0.7rem] block">
                    {rcData?.financier}
                  </span>
                </p>
              </div>
            )}
            <p className="text-right mt-4">
              <span className="block font-semibold text-[0.7rem] -mb-1">
                Registration Authority
              </span>
              <span className="text-[0.7rem] block">
                {rcData?.registered_at ? rcData?.registered_at : "N/A"}
              </span>
            </p>
            <p className="absolute -right-[20px] bottom-1/2 text-[0.7rem] -rotate-90">
              Form 23A
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
